import { createPublicClient } from '../../../../app/infrastructure/http/apiClient';
import type { PublicOffer } from '../../application/types';

type PublicOfferEnvelope = {
  data?: PublicOffer;
};

export async function fetchPublicOffer(): Promise<PublicOffer | null> {
  const response = await createPublicClient().get<PublicOfferEnvelope>(
    '/public/legal/public-offer',
  );
  return response.data?.data ?? null;
}
